// ts-gql-integrity:bde634c9ef7d5f1b51cb0897aa0cc664
/*
ts-gql-meta-begin
{
  "hash": "212994b2f06691ff83e94531b7c776fe"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type GetNotificationCountForUserQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


type GetNotificationCountForUserQuery = { getNotificationCountForUser: { unreadNotifications: number, jobRecurrences: number, jobSignOffRequests: number } };



export type type = TypedDocumentNode<{
  type: "query";
  result: GetNotificationCountForUserQuery;
  variables: {};
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    GetNotificationCountForUser: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"GetNotificationCountForUser\"},\"variableDefinitions\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"getNotificationCountForUser\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"unreadNotifications\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"jobRecurrences\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"jobSignOffRequests\"},\"arguments\":[],\"directives\":[]}]}}]}}]}")
